import React from 'react';
import {observer} from "mobx-react";
import {ExpandComponentProps} from "core/grid/component/gridComp";
import {action, ObservableMap} from "mobx";
import mdEntityService from "core/metamodel/mdEntityService";
import MdEntity from "core/metamodel/mdEntity";
import {GridRow} from "core/grid/domain/grid";
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/mergeMap';
import {EventHistory} from "core/event/eventDomain";
import eventService from "core/event/eventService";
import styled from "styled-components";
import {EventHistoryBlock} from "core/event/component/historyBlocks";

const itemStream = new Subject<any>();
itemStream
  .mergeMap((item) => Promise.all([item, eventService.readEventHistory(item.rowId as number), mdEntityService.fetchEntityMetadata(['EventHistory', 'HistoryObject', 'HistoryObjectField'])]), null, 5)
  .mergeMap(([item, eventHistory, entityMap]: [GridRow, EventHistory, ObservableMap<MdEntity>]) => Promise.all([item, eventHistory, mdEntityService.fetchEntityMetadata([eventHistory.entityName, ...eventHistory.historyObjects.map(ho => ho.entityName)])]))
  .subscribe(action("subscribe-actionCb", ([item, eventHistory, entityMap]: [GridRow, EventHistory, ObservableMap<MdEntity>]) => {
   item.rowObject = eventHistory;
   item.expanded = 2;
   console.log("EventExpando resolved event %s", eventHistory.eventHistoryId);
}));


const MDiv = styled.div`
  margin-left: 24px;
`;

@observer
export default class EventExpando extends React.Component<ExpandComponentProps, null> {


  componentDidMount() {
    let {item} = this.props;
    const eventHistory = item.rowObject as EventHistory;
    if (!eventHistory) {
      itemStream.next(item);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let {item} = this.props;
    const eventHistory = item.rowObject as EventHistory;
    if (!eventHistory && prevProps.item.rowId !== item.rowId ) {
      itemStream.next(item);
    }
  }



  render() {
    let {item} = this.props;
    const eventHistory = item.rowObject as EventHistory;

    console.log("EventExpando render vehicle %s, expanded = %s", (eventHistory)?eventHistory.eventHistoryId:null, item.expanded);

    if (item.expanded === 1) {
      return (
        <MDiv><i className="fa fa-refresh fa-2x fa-spin color-blue-grey-200"/></MDiv>
      );
    }

    return <EventHistoryBlock eventHistory={eventHistory} entities={mdEntityService.entityMap} />;
  }

}




// WEBPACK FOOTER //
// ./src/core/event/component/eventExpando.tsx